import { useMemo } from 'react';
import { useGetReferralInfoUserIdQuery } from 'src/store/services';
import { useGetUser } from 'src/hooks';

export const useGetReferralsInfo = () => {
  const { user_id, isSubscribedTier, isEnterpriseTrialTier } = useGetUser();

  const { data, isLoading } = useGetReferralInfoUserIdQuery(
    { user_id: user_id },
    {
      skip: !isSubscribedTier || isEnterpriseTrialTier,
    },
  );

  return useMemo(
    () => ({
      referralsInfo: data,
      url: data?.url || '',
      isReferralsLoading: isLoading,
      shouldShowFreeMonths: Boolean(data?.max_subscription_extension_months),
    }),
    [data, isLoading],
  );
};
